import type { SVGProps } from 'react'

export function FileFail(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.4592 8.0681C23.8903 8.0681 23.4298 7.60691 23.4298 7.03865V0H8.76637C8.38685 0 8.08008 0.306774 8.08008 0.686296V25.4973L9.46228 24.1151C9.86102 23.7143 10.5151 23.7102 10.9179 24.1151L11.876 25.0725L13.7578 23.1906C12.6817 21.8057 12.0407 20.0666 12.0407 18.1807C12.0407 13.5605 15.8881 9.82296 20.5466 10.0035C24.7934 10.1675 28.2345 13.6093 28.3999 17.8554C28.5811 22.5146 24.8435 26.3634 20.2234 26.3634C18.3375 26.3634 16.5984 25.7224 15.2134 24.6463L13.3316 26.5281L14.289 27.4855C14.6912 27.8876 14.6912 28.5396 14.289 28.9418L10.8548 32.376H30.9125C31.2913 32.376 31.5988 32.0686 31.5988 31.6897V8.0681H24.4592ZM17.0067 5.09575H11.876C11.307 5.09575 10.8465 4.63456 10.8465 4.0663C10.8465 3.49805 11.307 3.03686 11.876 3.03686H17.0067C17.575 3.03686 18.0362 3.49805 18.0362 4.0663C18.0362 4.63456 17.575 5.09575 17.0067 5.09575Z"
        fill="currentColor"
      />
      <path
        d="M25.4883 1.43408L30.12 6.009H25.4883V1.43408Z"
        fill="currentColor"
      />
      <path
        d="M3.79868 32.6894L10.1895 26.2986C10.4468 26.5567 11.9746 28.0841 12.1042 28.2133C11.3437 28.9739 6.46487 33.8527 5.71345 34.6041C5.18568 35.1319 4.32644 35.1319 3.79868 34.6041C3.27023 34.0764 3.27023 33.2171 3.79868 32.6894Z"
        fill="currentColor"
      />
      <path
        d="M20.2234 12.0562C16.8469 12.0562 14.0996 14.8034 14.0996 18.1807C14.0996 21.5545 16.8427 24.3045 20.2234 24.3045C23.6 24.3045 26.3472 21.5572 26.3472 18.1807C26.3472 14.8034 23.6 12.0562 20.2234 12.0562ZM22.6605 19.1621C23.0626 19.5635 23.0626 20.2155 22.6605 20.6177C22.2569 21.0212 21.6043 21.0171 21.2048 20.6177L20.2234 19.6363L19.242 20.6177C18.8385 21.0212 18.1858 21.0171 17.7864 20.6177C17.3842 20.2155 17.3842 19.5635 17.7864 19.1621L18.7678 18.1807L17.7864 17.1993C17.3842 16.7971 17.3842 16.1451 17.7864 15.7436C18.1886 15.3415 18.8399 15.3415 19.242 15.7436L20.2234 16.725C20.5975 16.351 20.5844 16.3633 21.2048 15.7436C21.607 15.3415 22.2583 15.3415 22.6605 15.7436C23.0626 16.1451 23.0626 16.7971 22.6605 17.1993L21.6791 18.1807L22.6605 19.1621Z"
        fill="currentColor"
      />
    </svg>
  )
}
